import React from "react"
import Slider from "react-slick"
import PropTypes from "prop-types"
import * as style from "./ProductSlider-tw-styles"
import ProductSliderCard from "./ProductSliderCard"

const ProductSlider = props => {
  const { slides } = props
  const settings = {
    arrows: true,
    centerMode: false,
    dots: false,
    pauseOnFocus: true,
    autoplaySpeed: 2000,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    focusOnSelect: false,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1601,
        settings: {
          arrows: false,
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          arrows: true,
          slidesToShow: 6,
        },
      },

      {
        breakpoint: 991,
        settings: {
          arrows: false,
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          slidesToShow: 3,
        },
      },
    ],
  }
  const styles = style?.ProductSliderStyles
  return (
    <div className={styles.sliderContainer}>
      <Slider {...settings}>
        {slides?.map((slide, idx) =>
          slide?.image && slide?.image?.imageDesktop.url !== "" ? (
            <div key={idx}>
              <ProductSliderCard {...slide} keyValue={slide?.elementid} />
            </div>
          ) : null
        )}
      </Slider>
    </div>
  )
}

ProductSlider.propTypes = {
  slides: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
}

export default ProductSlider
